import React from "react";
import { ToggleButton, ToggleButtonGroup, Tooltip } from "@mui/material";
import {
  DonutLarge as SunburstIcon,
  GridOn as HeatmapIcon,
  AccountTree as PipelineIcon,
} from "@mui/icons-material";
import type { ViewMode } from "./types";

interface Props {
  viewMode: ViewMode;
  onChange: (mode: ViewMode) => void;
}

const VIEWS: { value: ViewMode; icon: React.ReactNode; label: string }[] = [
  { value: "sunburst", icon: <SunburstIcon fontSize="small" />, label: "Sunburst — explore capability hierarchy" },
  { value: "heatmap", icon: <HeatmapIcon fontSize="small" />, label: "Heatmap — who covers what" },
  { value: "pipeline", icon: <PipelineIcon fontSize="small" />, label: "Pipeline — capability to use case flow" },
];

const CapabilityMapViewSwitcher: React.FC<Props> = ({ viewMode, onChange }) => (
  <ToggleButtonGroup
    value={viewMode}
    exclusive
    size="small"
    onChange={(_e, v) => { if (v) onChange(v); }}
    sx={{ "& .MuiToggleButton-root": { px: 1.5, py: 0.5 } }}
  >
    {VIEWS.map(({ value, icon, label }) => (
      <Tooltip key={value} title={label} placement="bottom">
        <ToggleButton value={value}>{icon}</ToggleButton>
      </Tooltip>
    ))}
  </ToggleButtonGroup>
);

export default CapabilityMapViewSwitcher;
